import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../Store';

// TYPES
import { IHttpError, initialState, IReconnectNotification, RECONNECT_NOTIFICATION_DEFAULTS } from './HttpState.types'; //IBalanceData, IBets, EWinType
import { TCreditionals } from '@Services/HttpService/HttpService.types';

// MANAGERS & SERVICES
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import HttpService from '@Services/HttpService/HttpService';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { TUserAction } from '@Managers/Events/GameEvents';

export const getConfigurationFiles = createAsyncThunk('http/getConfiguration', async () => {
    const reposne = await ConfigLoader.loadConfigurationFiles();
    return reposne;
});

export const checkUserSession = createAsyncThunk('http/checkUserSession', async (data: TCreditionals) => {
    const response = await HttpService.checkUserSessionRequest(data);
    return response;
});

export const userAction = createAsyncThunk('http/userAction', async (payload: TUserAction, state) => {
    const response = await HttpService.userAction(payload);

    return response;
});

export const getBalance = createAsyncThunk('http/getBalance', async () => {
    const response = await HttpService.getBalanceRequest();
    return response;
});

export const quitAction = createAsyncThunk('http/quitAction', async () => {
    const response = await HttpService.quitRequest();
    return response;
});

export const httpState = createSlice({
    name: 'http',
    initialState,
    reducers: {
        setHttpError: (state, action: PayloadAction<IHttpError>) => {
            state.httpError = action.payload;
        },
        setReconnectNotification: (state, action: PayloadAction<IReconnectNotification>) => {
            state.reconnectNotification = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkUserSession.pending, (state) => {
                state.sessionStatusCheck = 'Checking';
                Logger.log(LoggerLevel.ReducerState, { source: LoggerSource.React, message: 'REDUCER :: APP STATE :: checkUserSession.pending' });
            })
            .addCase(checkUserSession.fulfilled, (state, action) => {
                state.sessionStatusCheck = 'Check fulfilled';
                state.authenticateResponseData = action.payload as any;

                Logger.log(LoggerLevel.ReducerState, {
                    source: LoggerSource.React,
                    message: 'REDUCER :: APP STATE :: checkUserSession.fulfilled',
                    data: state.authenticateResponseData
                });
            })
            .addCase(userAction.pending, (state, action) => {
                Logger.log(LoggerLevel.ReducerState, { source: LoggerSource.React, message: 'REDUCER :: APP STATE :: userAction.pending' });
                state.pendingRequest = action.meta.arg;
            })
            .addCase(userAction.fulfilled, (state, action) => {
                if (action.payload.error) {
                    state.userActionResponseData = {
                        error: action.payload.error,
                        code: action.payload.code,
                        actionName: action.meta.arg.actionName
                    };
                } else {
                    state.httpError = false;
                    state.pendingRequest = false;
                    state.userActionResponseData = { ...action.payload, actionName: action.meta.arg.actionName };
                }

                Logger.log(LoggerLevel.ReducerState, {
                    source: LoggerSource.React,
                    message: 'REDUCER :: APP STATE :: userAction.fulfilled',
                    data: action.payload
                });
            })
            .addCase(getConfigurationFiles.pending, (state) => {
                Logger.log(LoggerLevel.ReducerState, { source: LoggerSource.React, message: 'REDUCER :: APP STATE :: getConfigurationFiles.pending' });
            })
            .addCase(getConfigurationFiles.fulfilled, (state, action) => {
                state.configurationDataLoaded = true;
                Logger.log(LoggerLevel.ReducerState, {
                    source: LoggerSource.React,
                    message: 'REDUCER :: APP STATE :: getConfigurationFiles.fulfilled',
                    data: state.authenticateResponseData
                });
            })
            .addCase(getBalance.pending, (state, action) => {})
            .addCase(getBalance.fulfilled, (state, action) => {})
            .addCase(quitAction.pending, (state, action) => {})
            .addCase(quitAction.fulfilled, (state, action) => {});
    }
});

export const { setHttpError, setReconnectNotification } = httpState.actions;
export const httpReducer = httpState.reducer;

export const getConfigurationDataLoadedState = (state: RootState) => state.http.configurationDataLoaded;
export const getAuthenticateData = (state: RootState) => state.http.authenticateResponseData;
export const getUserActionResponseData = (state: RootState) => state.http.userActionResponseData;
export const getHttpError = (state: RootState) => state.http.httpError;
export const getSessionStatusCheck = (state: RootState) => state.http.sessionStatusCheck;
export const getPendingRequestData = (state: RootState) => state.http.pendingRequest;
export const getReconnectNotification = (state: RootState) => state.http.reconnectNotification;
